export type WeightUnit = "kg" | "lbs";

export const sanitizeWeightInput = (value: string) => {
  const normalizedSeparator = value.replace(/,/g, ".");
  const numericOnly = normalizedSeparator.replace(/[^\d.]/g, "");
  if (!numericOnly) return "";

  const [integerPart, ...decimalParts] = numericOnly.split(".");
  const hasDecimalPoint = decimalParts.length > 0;
  const firstDecimalDigit = decimalParts.join("").replace(/\./g, "").slice(0, 1);

  if (!hasDecimalPoint) return integerPart;
  if (!firstDecimalDigit) return `${integerPart || "0"}.`;

  return `${integerPart || "0"}.${firstDecimalDigit}`;
};

export const normalizeInitialWeight = (value: string) => {
  const sanitized = sanitizeWeightInput(value ?? "");
  const numeric = parseFloat(sanitized);
  if (!Number.isFinite(numeric) || numeric <= 0) return "";
  return sanitized;
};

export const normalizeWeightForSubmit = (value: string) => {
  const sanitized = sanitizeWeightInput(value ?? "");
  const numeric = parseFloat(sanitized);
  if (!Number.isFinite(numeric)) return "";
  const rounded = Number(numeric.toFixed(1));
  // Both save paths (Confirm button and keyboard Enter/Go) go through here, so
  // reject 0 here rather than relying on the button's disabled state.
  if (rounded <= 0) return "";
  return rounded.toString();
};

export const convertWeight = (value: string, from: WeightUnit, to: WeightUnit) => {
  const numeric = parseFloat(value);
  if (Number.isNaN(numeric)) return "";
  if (from === to) return sanitizeWeightInput(value);

  const converted = from === "kg" ? numeric * 2.20462 : numeric / 2.20462;
  return sanitizeWeightInput(Number(converted.toFixed(1)).toString());
};
